export default __webpack_public_path__ + "static/fireFlyLogo-1d1fb73a9874510b3e130c7d8cb7c77c.png";